<template>
  <div class="product">
    <div class="product-top">
      <div class="product-top__name">产品储备计划单</div>
      <div class="product-top__fun">
        <div class="product-top-item product-top-item--date">
          <div class="product-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="product-top-item product-top-item--date">
          <div class="product-top-item__name">计划交货日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="product-top-item">
          <div class="product-top-item__name">采购状态:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="product-top-item">
          <div class="product-top-item__name">入仓状态:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="product-top__btn">搜索</div>
        <div class="product-top__btn" @click="newProductReservesBtnClick">新建产品储备计划单</div>
      </div>
    </div>
    <div class="product-table">
      <Table :head="tableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { ProductReservesSearchData, ProductReservestNewModule } from './class'
import Table from 'components/common/Table.vue'
export default {
  name: 'productReserves',
  components: {
    Table
  },
  data(){
    return{
      /**搜索数据 */
      searchData: new ProductReservesSearchData(),
      /**表头 */
      tableHead: ProductReservestNewModule.NEWTABLEHEAD()
    }
  },
  methods: {
    /**新建发补货计划单 */
    newProductReservesBtnClick(){
      this.$emit('go', {
        id: 'newProductReserves',
        name: '新建产品储备计划单',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
